// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ak-3";
export var contentContainer = "_ak-0";
export var editorContainer = "_ak-1";
export var quillInputForm = "_ak-2";
export var zoneDivider = "_ak-4";